import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Lots_ds_reason_codes_ddService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { fullTextSearch?: string, id?: number }): 
  Promise<{ result: { Id?: number, Label?: string, LookupCode?: string, Name?: string }[] }> 
  {
    let url = `${environment.backendUrl}api/Lots/datasources/ds_reason_codes_dd/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { fullTextSearch?: string, id?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Label?: string, LookupCode?: string, Name?: string }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Lots/datasources/ds_reason_codes_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { fullTextSearch?: string, id?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, Label?: string, LookupCode?: string, Name?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Lots/datasources/ds_reason_codes_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
